export const money = (minor) => `₦${((Number(minor) || 0) / 100).toLocaleString("en-NG", { maximumFractionDigits: 2 })}`;

export const EVENT_LABELS = {
  OBLIGATION_CHARGED: "School fee charged", OBLIGATION_REVERSED: "Charge cancelled",
  SCHOLARSHIP_APPLIED: "Scholarship applied",
  SCHOLARSHIP_REVERSED: "Scholarship reversed", PAYMENT_RECEIVED: "Payment received",
  PAYMENT_ALLOCATED: "Payment allocated", PAYMENT_ALLOCATION_REVERSED: "Payment allocation reversed",
  PAYMENT_REFUNDED: "Payment refunded",
};

const rolesOf = (user) => new Set(user?.roles || (user?.role ? [user.role] : []));
const paymentRoles = new Set(["super_admin", "director", "accountant", "receptionist"]);

export const parseMinor = (value) => {
  const clean = String(value || "").replace(/,/g, "").trim();
  if (!/^\d+(\.\d{1,2})?$/.test(clean)) return null;
  const [whole, fraction = ""] = clean.split(".");
  const minor = Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
  return Number.isSafeInteger(minor) && minor > 0 ? minor : null;
};

export const familyPlacementDetails = (data, studentId) => (data?.placements || [])
  .filter((item) => item.student_id === studentId)
  .map((item) => ({
    placement: item,
    detail: {
      statement: {
        total_charged_minor: item.charged_minor,
        total_scholarship_minor: item.scholarship_minor,
        total_allocated_minor: item.paid_minor,
        available_credit_minor: item.available_credit_minor,
        outstanding_balance_minor: item.outstanding_minor,
        reconciliation: { status: item.reconciliation_status },
      },
      invoices: (item.invoices || []).map((invoice) => ({ ...invoice, id: invoice.invoice_id, net_balance_minor: invoice.outstanding_minor })),
    },
  }));

export const canRecordFinancePayment = (user) => [...rolesOf(user)].some((role) => paymentRoles.has(role));
export const canManageScholarships = (user) => rolesOf(user).has("super_admin") || rolesOf(user).has("director");
export const canFinalizeFinanceReversal = (user) => {
  const capabilities = new Set(user?.capabilities || user?.permissions || []);
  return capabilities.has("finance.reversal.finalize")
    || rolesOf(user).has("super_admin")
    || rolesOf(user).has("director");
};

export const bankAllocationPreview = (receivedMinor, outstandingMinor = 0) => {
  const received = Math.max(0, Number(receivedMinor || 0));
  const outstanding = Math.max(0, Number(outstandingMinor || 0));
  const allocated = Math.min(received, outstanding);
  return { receivedMinor: received, allocatedMinor: allocated, availableCreditMinor: received - allocated };
};

export const explicitAllocationPlan = (invoices = [], allocationAmounts = {}) => {
  const allocations = invoices.map((invoice) => ({ invoice, amountMinor: parseMinor(allocationAmounts[invoice.id]) || 0 })).filter((item) => item.amountMinor > 0);
  return { allocations, totalMinor: allocations.reduce((sum, item) => sum + item.amountMinor, 0), exceedsOutstanding: allocations.some(({ invoice, amountMinor }) => amountMinor > Number(invoice.net_balance_minor || 0)) };
};
